<avi-progress-bar
    class="transition-progress-bar"
    [hidden]="!showProgressbar"
    [small]="true"
    [percentage]="percentage"
    [hidePercentage]="true"
></avi-progress-bar>
